// import { useEffect, useState } from 'react';
// import PropTypes from 'prop-types';
// import { OverlayTrigger, Popover } from 'react-bootstrap';
// import Plot from 'react-plotly.js';
// import {
//   ManRadioButtonGroup,
//   ManRadioButton,
//   ManText
// } from '@craft-design-system/core-components-react';
// import Shimmer_graph from '../shimmer_graph';
// import { useResetContext } from '../ResetContext';
// import useGraphRadio from '../../utils/useGraphRadio';
// import useSegmentedChartQuery from '../../utils/useSegmentedChartQuery';
// import AverageDisplay from '../ride_analysis_kpi/Average_value';
// import DownloadButtonComponent from '../DownloadButtonComponent';
// import SegmentedControl from '../ride_analysis_kpi/SegmentedControl';
// import { CustomTextDisplay } from '../AI';
// import Zoom from '../Zoom';
// import ifav from './ifav.png';

// const Charging_cycle_current = ({ value }) => {
//   const [charging_cycle_current, set_charging_cycle_current] = useState(null);
//   const [downloadData, setDownloadData] = useState([]);
//   const [radio_buttons_test, set_Radio_values] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [chartType, setChartType] = useState("Bar");
//   const { resetdata } = useResetContext();
//   const radio_query = useGraphRadio();
//   const { fetchSegmentedChart } = useSegmentedChartQuery();
//   const [isInitialLoad, setIsInitialLoad] = useState(true);
  
//   const [avg_value, setavg_value] = useState(
//     value?.chargingCycleCurrent?.[2]?.average || 0
//   );

//   const popover = (
//     <Popover id="popover-basic">
//       <Popover.Body>
//         <strong>Definition:</strong><br />
//         This KPI displays the charging current during charging cycles.<br /><br />
  
//         <strong>Telematic raw data for this KPI:</strong><br />
//         TBM3:<br />
//         • batterycurrent<br />
//         CM4:<br />
//         • batterycurrent<br />
//         • batcurrcbp<br /><br />
  
//         <strong>Time series data:</strong><br />
//         If multiple vehicles are selected, average values are displayed. Days without data are not taken into account for the calculation.
//       </Popover.Body>
//     </Popover>
//   );

//   const handleSelectChange1 = (event) => {
//     set_Radio_values((prevValues) => ({
//       ...prevValues,
//       [event.detail.name]: event.detail.value,
//     }));
//   };
//   useEffect(() => {
//     if (radio_buttons_test) {
//       setIsLoading(true);
//       radio_query({
//         vins_short: [value.vin_short],
//         radio_value: radio_buttons_test,
//         columnname: 'Charging Cycle Current',
//         category: resetdata,
//         chartType,
//       }).then(data => {
//         set_charging_cycle_current(JSON.parse(data['jsonData'][0]));
//         setavg_value(data['jsonData'][2]?.average || 0);
//         setDownloadData(JSON.parse(data['jsonData'][3]));
//         setIsLoading(false);
//       });
//     }
//   }, [radio_buttons_test]);

//   useEffect(() => {
//     try {
//       if (value?.chargingCycleCurrent?.[0]) {
//         set_charging_cycle_current(JSON.parse(value.chargingCycleCurrent[0]));
//       }
//       if (value?.chargingCycleCurrent?.[3]) {
//         setDownloadData(JSON.parse(value.chargingCycleCurrent[3]));
//       }
//     } catch (error) {
//       console.error("Error parsing JSON", error);
//     }
//   }, [value]);

//   return (
    
//     <div style={{ padding: '16px' }}>
//     {/* Title + Info */}
//     <div style={{
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       marginBottom: '8px',
//       gap: '8px'
//     }}>
//       <div style={{
//         flex: 1,
//         textAlign: 'center',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         marginLeft: '130px'
//       }}>
//         <ManText
//           className="card-title-text"
//           variant="component-l"
//           as="span"
//           size="l"
//           style={{ lineHeight: 'normal' }}
//         >
//          Cycle current
//         </ManText>
//       </div>
//       <div style={{
//         flexShrink: 0,
//         display: 'flex',
//         alignItems: 'center',
//         height: '100%',
//         flexDirection: "row-reverse"
//       }}>
//         {/* <PopoverComponent
//           id="charging_time"
//           content={tooltipContent}
//         /> */}
//         <OverlayTrigger trigger="hover" placement="left" overlay={popover}>
//           <img className="man-logovv1" src={ifav} alt="info" />
//         </OverlayTrigger>
//         <Zoom
//           chartData={charging_cycle_current?.data}
//           chartLayout={charging_cycle_current?.layout}
//           chartTitle="Charging cycle count"
//         />
//         <DownloadButtonComponent
//           data={downloadData}
//           fileName={`charging_cycle_current_${chartType.toLowerCase()}_${radio_buttons_test?.['Charging Cycle Current']?.toLowerCase() || 'daily'}.xlsx`}
//         />
//       </div>
//     </div>


//       <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '20px', marginTop: '16px' }}>
//         <div style={{ flexShrink: 0 }}>
//           <AverageDisplay averages={avg_value} unit="A" />
//         </div>
//         <div style={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
//         <ManRadioButtonGroup
//           name="Charging Cycle Current"
//           invalid="false"
//           onManChange={handleSelectChange1}
//           style={{ display: 'flex', gap: '20px' }}
//         >
//           <ManRadioButton name="Charging Cycle Current" label="Daily" value="Daily" checked />
//           <ManRadioButton name="Charging Cycle Current" label="Monthly" value="Monthly" />
//           <ManRadioButton name="Charging Cycle Current" label="Yearly" value="Yearly" />
//         </ManRadioButtonGroup>
//         </div>
//         {/* <div style={{ marginLeft: 'auto' }}>
//           <SegmentedControl
//             selected={chartType}
//             onChange={(type) => setChartType(type)}
//             options={["Bar"]}
//           />
//         </div> */}
//       </div>

//       <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
//         {isLoading ? (
//           <Shimmer_graph />
//         ) : (
//           charging_cycle_current && (
//             <>
//               <Plot
//                 data={charging_cycle_current.data}
//                 layout={{
//                   ...charging_cycle_current.layout,
//                   margin: { t: 10, r: 10, l: 10, b: 160 },
//                   xaxis: {
//                     ...charging_cycle_current.layout?.xaxis,
//                     rangeslider: { visible: false },
//                   },
//                   autosize: true,
//                   responsive: true,
//                 }}
//                 useResizeHandler={true}
//                 style={{ width: '100%', height: '100%' }}
//               />
//               {/* <CustomTextDisplay
//                 title="AI | Automotive Intelligence"
//                 isValueStyled
//               /> */}
//             </>
//           )
//         )}
//       </div>
//     </div>
//   );
// };

// Charging_cycle_current.propTypes = {
//   value: PropTypes.shape({
//     vin_short: PropTypes.string.isRequired,
//     chargingCycleCurrent: PropTypes.array.isRequired,
//   }).isRequired,
// };

// export default Charging_cycle_current;

import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import Plot from 'react-plotly.js';
import {
  ManRadioButtonGroup,
  ManRadioButton,
  ManText
} from '@craft-design-system/core-components-react';
import Shimmer_graph from '../shimmer_graph';
import { useFilterContext } from '../FilterContext';
import { useResetContext } from '../ResetContext';
import useGraphRadio from '../../utils/useGraphRadio';
import useSegmentedChartQuery from '../../utils/useSegmentedChartQuery';
import AverageDisplay from '../ride_analysis_kpi/Average_value';
import DownloadButtonComponent from '../DownloadButtonComponent';
import SegmentedControl from '../ride_analysis_kpi/SegmentedControl';
import { CustomTextDisplay } from '../AI';
import AIToggleButton from '../AIToggleButton'; // 🔥 Added AI Toggle Button
import Zoom from '../Zoom';
import ifav from './ifav.png';

const Charging_cycle_current = ({ value }) => {
  const [charging_cycle_current, set_charging_cycle_current] = useState(null);
  const [downloadData, setDownloadData] = useState([]);
  const [radio_buttons_test, set_Radio_values] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [chartType, setChartType] = useState("Bar");
  const { filterdata } = useFilterContext();
  const { startDate, endDate } = filterdata || {};
  const { resetdata } = useResetContext();
  const radio_query = useGraphRadio();
  const { fetchSegmentedChart } = useSegmentedChartQuery();
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  // 🔥 AI-related state
  const [cleanedAIData, setCleanedAIData] = useState([]);
  const [radioButtons, setRadioButtons] = useState({
    'Charging Cycle Current': 'Daily'
  });

  const [avg_value, setavg_value] = useState(
    value?.chargingCycleCurrent?.[2]?.average || 0
  );

  // 🔥 Clean download data for AI insights
  useEffect(() => {
    if (downloadData && downloadData.length > 0) {
      const cleanData = downloadData.filter(item => 
        item && typeof item === 'object' && Object.keys(item).length > 0
      );
      setCleanedAIData(cleanData);
    }
  }, [downloadData]);

  const popover = (
    <Popover id="popover-basic">
      <Popover.Body>
        <strong>Definition:</strong><br />
        This KPI displays the charging current during charging cycles.<br /><br />
  
        <strong>Telematic raw data for this KPI:</strong><br />
        TBM3:<br />
        • batterycurrent<br />
        CM4:<br />
        • batterycurrent<br />
        • batcurrcbp<br /><br />
  
        <strong>Time series data:</strong><br />
        If multiple vehicles are selected, average values are displayed. Days without data are not taken into account for the calculation.<br /><br />

        <strong>Histogram:</strong><br />
        Each bar represents the number of charging cycles that fall within a certain range (bin) of <strong>current values.</strong><br />
        All charging current values since start of data acquisition for the selected vehicle(s) are visualized per default.<br /><br />
  
        <strong>Boxplot:</strong><br />
        The boxplot shows the <strong>distribution of charging current values</strong> for the selected vehicle(s) since start of data acquisition.<br />
        If multiple vehicles are selected, the boxplot reflects the combined distribution of all their values.<br />
        • The <strong>box</strong> represents the middle 50% of values (from the 25th percentile ("q1") to the 75th percentile ("q3")).<br />
        • The line <strong>inside the box</strong> shows the median (50th percentile).<br />
        • The whiskers extend to show the range of typical values ("min" and "max") and visualize <strong>the spread of the data</strong> beyond the central box.
      </Popover.Body>
    </Popover>
  );

  const handleSelectChange1 = (event) => {
    console.log('📻 Radio button changed:', event.detail.name, event.detail.value);
    
    const newRadioValues = {
      ...radio_buttons_test,
      [event.detail.name]: event.detail.value,
    };
    set_Radio_values(newRadioValues);
    
    // 🔥 Update radio buttons state for AI insights
    setRadioButtons(newRadioValues);
  };

  // 🔥 Fetch data when chart type changes
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        console.log('📊 Fetching segmented chart with category:', resetdata);
        
        const data = await fetchSegmentedChart({
          vinShort: value.vin_short,
          chartType,
          category: resetdata,
          columnname: 'Charging Cycle Current',
        });

        if (chartType === 'Bar') {
          set_charging_cycle_current(JSON.parse(data[0]));
          setDownloadData(JSON.parse(data[3]));
        } else {
          set_charging_cycle_current(JSON.parse(data[0]));
          setDownloadData(JSON.parse(data[1]));
        }
      } catch (error) {
        console.error('Error fetching chart data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    if (!isInitialLoad && chartType && value?.vin_short) {
      fetchData();
    } else {
      setIsInitialLoad(false);
    }
  }, [chartType, resetdata]);

  // 🔥 Handle radio button changes - enhanced like other components
  useEffect(() => {
    if (!radio_buttons_test) return;

    console.log('📻 Radio fetch triggered with:', radio_buttons_test);
    console.log('📻 Current category (resetdata):', resetdata);

    setIsLoading(true);

    // 🔥 Enhanced params to include category properly
    const params = {
      vins_short: [value.vin_short],
      radio_value: radio_buttons_test,
      columnname: 'Charging Cycle Current',
      startDate,
      endDate,
      filterdata: {
        ...filterdata,
        category: resetdata,
        resetdata: resetdata
      },
      resetdata: resetdata,
      category: resetdata,
      chartType,
    };

    console.log('📻 Sending radio query with params:', params);

    radio_query(params)
      .then(res => {
        console.log('📻 Radio query response:', res);

        // 🔥 Support BOTH response formats
        const payload = res.jsonData ?? res;
        
        if (payload) {
          set_charging_cycle_current(JSON.parse(payload[0]));
          setavg_value(payload[2]?.average || 0);
          setDownloadData(JSON.parse(payload[3]));
        }
      })
      .catch(err => {
        console.error("❌ Radio fetch failed:", err);
      })
      .finally(() => setIsLoading(false));

  }, [radio_buttons_test, resetdata, chartType]);

  // 🔥 Initialize data from props
  useEffect(() => {
    try {
      if (value?.chargingCycleCurrent?.[0]) {
        set_charging_cycle_current(JSON.parse(value.chargingCycleCurrent[0]));
      }
      if (value?.chargingCycleCurrent?.[3]) {
        setDownloadData(JSON.parse(value.chargingCycleCurrent[3]));
      }
    } catch (error) {
      console.error("Error parsing JSON", error);
    }
  }, [value]);

  // 🔥 Monitor resetdata changes
  useEffect(() => {
    console.log('🔄 resetdata changed to:', resetdata);
    
    // If we have radio buttons selected and resetdata changes, refetch
    if (radio_buttons_test && resetdata) {
      console.log('🔄 Refetching due to category change');
      // Trigger refetch by updating radio buttons state slightly
      set_Radio_values({...radio_buttons_test});
    }
  }, [resetdata]);

  return (
    <div style={{ padding: '16px' }}>
      {/* Debug info - remove in production */}
      {/* <div style={{ fontSize: '12px', color: '#666', marginBottom: '8px' }}>
        Debug: Category = {resetdata || 'None'}, Radio = {JSON.stringify(radio_buttons_test)}
      </div> */}

      {/* Title + Info */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '8px',
        gap: '8px'
      }}>
        <div style={{
          flex: 1,
          textAlign: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginLeft: '130px'
        }}>
          <ManText
            className="card-title-text"
            variant="component-l"
            as="span"
            size="l"
            style={{ lineHeight: 'normal' }}
          >
            Cycle current
          </ManText>
        </div>
        <div style={{
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          height: '100%',
          flexDirection: "row-reverse",
          gap: 10 // 🔥 Added gap for consistent spacing
        }}>
          <OverlayTrigger trigger="hover" placement="left" overlay={popover}>
            <img 
              className="man-logovv1" 
              src={ifav} 
              alt="info" 
              style={{ 
                cursor: 'pointer',
                alignSelf: 'center' // 🔥 Ensures info icon aligns with other icons
              }} 
            />
          </OverlayTrigger>
          <Zoom
            chartData={charging_cycle_current?.data}
            chartLayout={charging_cycle_current?.layout}
            chartTitle="Charging cycle current"
          />
          <DownloadButtonComponent
            data={downloadData}
            fileName={`charging_cycle_current_${chartType.toLowerCase()}_${radio_buttons_test?.['Charging Cycle Current']?.toLowerCase() || 'daily'}.xlsx`}
          />
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '20px', marginTop: '16px' }}>
        {chartType === 'Bar' ? (
          <div style={{ flexShrink: 0 }}>
            <AverageDisplay averages={avg_value} unit="A" />
          </div>
        ) : (
          <div style={{ width: '150px' }} />
        )}
        
        <div style={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
          {chartType === "Bar" ? (
            <ManRadioButtonGroup
              name="Charging Cycle Current"
              invalid="false"
              onManChange={handleSelectChange1}
              style={{ display: 'flex', gap: '20px' }}
            >
              <ManRadioButton name="Charging Cycle Current" label="Daily" value="Daily" checked />
              <ManRadioButton name="Charging Cycle Current" label="Monthly" value="Monthly" />
              <ManRadioButton name="Charging Cycle Current" label="Yearly" value="Yearly" />
            </ManRadioButtonGroup>
          ) : (
            <div style={{ flexGrow: 1 }} />
          )}
        </div>

        <div style={{ marginLeft: 'auto' }}>
          <SegmentedControl
            selected={chartType}
            onChange={(type) => setChartType(type)}
            options={["Bar", "Histogram", "Boxplot"]} // 🔥 Added Histogram and Boxplot options
          />
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
      {isLoading ? (
        <Shimmer_graph />
      ) : (
        charging_cycle_current && (
          <>
            <Plot
              data={charging_cycle_current.data}
              layout={{
                ...charging_cycle_current.layout,
                margin: chartType === 'Bar' 
                  ? { t: 10, r: 10, l: 10, b: 160 } // 🔥 Reduced margin since button is moved outside
                  : { t: 10, r: 10, l: 10, b: 180 },
                autosize: true,
                responsive: true,
                xaxis: {
                  ...charging_cycle_current.layout?.xaxis,
                  rangeslider: { visible: false },
                },
              }}
              useResizeHandler={true}
              style={{ 
                width: '100%', 
              }}
            />

            {/* 🔥 AI Toggle Button - Bottom left corner */}
            {chartType === 'Bar' && cleanedAIData?.length > 0 && (
              <div style={{ 
                display: 'flex', 
                justifyContent: 'flex-start', // 🔥 Left alignment
                marginTop: '16px' // 🔥 Space from chart
              }}>
                <AIToggleButton
                  downloadData={cleanedAIData}
                  radioButtonState={radioButtons}
                  kpiName="Charging Cycle Current [A]"
                  chartType={chartType}
                  vinShort={value.vin_short}
                  title="AI | Automotive Intelligence - Charging Cycle Current Analysis"
                />
              </div>
            )}
          </>
        )
      )}
    </div>
    </div>
  );
};

Charging_cycle_current.propTypes = {
  value: PropTypes.shape({
    vin_short: PropTypes.string.isRequired,
    chargingCycleCurrent: PropTypes.array.isRequired,
  }).isRequired,
};

export default Charging_cycle_current;
